import { buildSubscriptionPanel } from '../subscriptionPanel';

/** Public pricing destination used by the sitemap, SEO shell and SPA router. */
export const pricingMarkup = String.raw`<!-- ====== PRICING VIEW ====== -->
    <div class="view" id="view-pricing">
      <section class="pricing-page" aria-labelledby="pricing-page-title">
        <header class="pricing-page-header">
          <span class="pricing-page-eyebrow">Simple, transparent membership</span>
          <h1 class="heading-1" id="pricing-page-title">Choose the plan that fits how you learn.</h1>
          <p>Preview public topics first, then choose the access you need for every public topic, media modes, and private topics.</p>
        </header>
		${buildSubscriptionPanel({ prefix: 'pricing', mode: 'checkout' })}
        <div class="pw-assurance pricing-page-assurance" aria-label="Subscription terms">
          <span><span><strong>Secure checkout</strong><small>Encrypted payment</small></span></span>
          <span><span><strong>Cancel anytime</strong><small>Manage renewal from your profile</small></span></span>
          <span><span><strong>Progress stays yours</strong><small>Your learning history is kept</small></span></span>
        </div>
      </section>
    </div>

    `;
